module.exports = __webpack_public_path__ + "static/media/avatar-3.963e5dbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/happy-customers/avatar-3.png
// module id = 2295
// module chunks = 0